
import Reflux from 'reflux';
import { MetaDataActions } from './actions';

export class MetaDataStore extends Reflux.Store {
    constructor() {
        super();
        this.state = this.getInitialState();
        this.listenables = [MetaDataActions];
    }
    getInitialState() {
        return {
            description: '',
            titleTag: ''
        };
    }
    onSetTitle(titleTag=''){
        this.setState({
            titleTag: titleTag
        });
    }
    onSetDescription(description=''){
        this.setState({
            description: description
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/page-content/meta-data-tags/store.js